module.exports = __webpack_public_path__ + "static/media/deposit.d9daedaf.svg";